/*eslint-disable*/
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
import ReadMasterAxios from '../axiosComponent/readMaster';
const MyMovementType = ({
    field: { name },
    form: { setFieldValue },
    mappedBillingParty,
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    const [values, setValues] = useState([])
    useEffect(() => {
        setloading(true)
            ReadAxios({
                completeURL: `${process.env.REACT_APP_MASTER_API}/movementType/:`,
              }).then((response) => {
                if (response.data.resultSet.length > 0) {
                    setcontent(response.data.resultSet)
                    setloading(false)
                }
            })
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
                temp.key = object.movementTypeId
                temp.text = `${object.movementType}`
                temp.value = object.movementTypeId
                temp.name = object.movementType
                return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
            setFieldValue(name, data.value)
            if(props.nameValue && data.value.length>0){
               setFieldValue(props.nameValue, data.options)
            }
    }
    return (
        <>
            <Dropdown
                selection
                loading={loading ? true : false}
                style={{ width: '100%' }}
                onChange={handleChange}
                options={options}
                noResultsMessage="Search for Result"
                {...props}
            />
        </>
    )
}
export default MyMovementType